import { Component } from "react";
import { Link } from "../../utils/PostInternals";
import { Text, View } from "../ui";
import { getMediaBlocks } from "./utils/LinkContentUtils";
import {
  getCardImage, getExcerpt, getTitle
} from "./utils/LinkReactUtils";

interface LinkCardProps {
  activePost: any;
  activeLink: Link | undefined;
  height?: number;
  onClick: () => void;
  containerProps?: any;
  infoblockProps?: any;
}

interface LinkCardState {}

export class LinkCard extends Component<LinkCardProps, LinkCardState> {
  getInfoBlock(activeLink: Link, infoblockProps, activePost?) {
    if (!activeLink || activeLink?.hideTitle) {
      return null;
    }

    return (
      <View key={"infoblock" + activeLink?.id} style={infoblockProps?.style}>
        {/* {getLinkType(activeLink, infoblockProps)} */}
        <View style={{ margin: 0 }} />
        {getTitle(activeLink, infoblockProps)}
        <View style={{ margin: 0 }} />
        {getExcerpt(activeLink, infoblockProps)}
        <View style={{ margin: 0 }} />
        {/* {getAuthor(activeLink, infoblockProps)} */}
        <View style={{ margin: 0 }} />
        {/* {getTags(activeLink, infoblockProps, activePost)} */}
      </View>
    );
  }

  render() {
    const { activeLink,activePost, onClick } = this.props;
    const { containerProps, infoblockProps } = this.props;

    if (!activeLink) {
      return (
        <View>
          <Text>No link is selected</Text>
        </View>
      );
    }

    // var featureBlocks = getFeatureBlocks(activeLink);
    const featureBlocks = activeLink?.content?.blocks;
    const mediaBlocks = getMediaBlocks(featureBlocks || []);

    const defaultInfoBlockProps = {
      style: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        paddingTop: 32,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
        display: "flex",
        flexDirection: "column",
        zIndex: 3,
        textAlign: "start",
        background:
          "linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.55) 60%, rgba(0,0,0,0) 100%)",
      },
    };

    const defaultContainerProps = {
      style: {
        position: "relative",
        borderRadius: 14,
        width: "100%",
        height: mediaBlocks?.length ? undefined : 200,
        backgroundColor: "#e9eef5",
        textAlign: "start",
        minHeight: 200,
        overflow: "hidden",
        cursor: "pointer",
        boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
      },
    };

    const containerStyle = {
      ...defaultContainerProps?.style,
      ...containerProps?.style,
    };

    return (
      <View
        key="LinkCard"
        style={containerStyle}
        onClick={onClick}
      >
        {mediaBlocks?.length
          ? getCardImage(activeLink, containerStyle.width, containerStyle.height)
          : null}
        {this.getInfoBlock(
          activeLink,
          {
            ...defaultInfoBlockProps,
            ...infoblockProps,
          },
          activePost
        )}
      </View>
    );
  }
}
